module.exports = __webpack_public_path__ + "images/psp/hero/24-hour-hero.webp";